import React, { useEffect } from 'react'
import { Alert, AlertIcon, AlertTitle, AlertDescription, position, Button } from '@chakra-ui/react';

export default function CustomAlertWeb({status, message, onClose}) {
    useEffect(() => {
        setTimeout(() => {
            onClose()
        }, 3000)
    }, [])
    return (
        <Alert status={status} style={{
            position: 'fixed',
            top: 10,
            left: '40vw',
            display: 'flex',
            flexDirection: 'row',
            maxWidth: '25%'
        }}>
          <AlertIcon />
          <AlertTitle>{status}</AlertTitle>
          <AlertDescription>{message}</AlertDescription>
        </Alert>
      );
}
